import {
  CREATE_CLIENT,
  CREATE_CLIENT_FAILURE,
  CREATE_CLIENT_SUCCESS,
  DELETE_CLIENT,
  DELETE_CLIENT_FAILURE,
  DELETE_CLIENT_SUCCESS,
  GET_CLIENTS,
  GET_CLIENTS_FAILURE,
  GET_CLIENTS_SUCCESS,
  GET_SINGLE_CLIENT,
  GET_SINGLE_CLIENT_FAILURE,
  GET_SINGLE_CLIENT_SUCCESS,
  UPDATE_CLIENT,
  UPDATE_CLIENT_FAILURE,
  UPDATE_CLIENT_SUCCESS,
} from "./actionTypes";

export const getClients = (payload) => {
  return {
    type: GET_CLIENTS,
    payload,
  };
};

export const getClientsSuccess = (payload) => {
  return {
    type: GET_CLIENTS_SUCCESS,
    payload,
  };
};

export const getClientsFailure = (payload) => {
  return {
    type: GET_CLIENTS_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const getSingleClient = (payload) => {
  return {
    type: GET_SINGLE_CLIENT,
    payload,
  };
};

export const getSingleClientSuccess = (payload) => {
  return {
    type: GET_SINGLE_CLIENT_SUCCESS,
    payload,
  };
};

export const getSingleClientFailure = (payload) => {
  return {
    type: GET_SINGLE_CLIENT_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const createClient = (payload) => {
  return {
    type: CREATE_CLIENT,
    payload,
  };
};

export const createClientSuccess = (payload) => {
  return {
    type: CREATE_CLIENT_SUCCESS,
    payload,
  };
};

export const createClientFailure = (payload) => {
  return {
    type: CREATE_CLIENT_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const updateClient = (payload) => {
  return {
    type: UPDATE_CLIENT,
    payload,
  };
};

export const updateClientSuccess = (payload) => {
  return {
    type: UPDATE_CLIENT_SUCCESS,
    payload,
  };
};

export const updateClientFailure = (payload) => {
  return {
    type: UPDATE_CLIENT_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const deleteClient = (payload) => {
  return {
    type: DELETE_CLIENT,
    payload,
  };
};

export const deleteClientSuccess = (payload) => {
  return {
    type: DELETE_CLIENT_SUCCESS,
    payload,
  };
};

export const deleteClientFailure = (payload) => {
  return {
    type: DELETE_CLIENT_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================
